import './sass/main.scss';
import './js/mobile-menu';
import './js/theme-changer';
import './js/navigation-highlight';
import './js/support.js';
import './js/modal-registration';
import './js/shopping-list';
import './js/firebase';
import './js/pop-up';
